import dayjs from 'dayjs'

import CardActionArea from '@mui/material/CardActionArea'
import Chip from '@mui/material/Chip'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import { alpha } from '@mui/material/styles'
import Typography from '@components/_mui/Typography'

const MAX_CATEGORIES = 3

export default function SOP({ data, selected, onSelect }) {
  const testId = `sop-${data.title?.substring(0, 10)}`
  const categories = data.categories ?? []
  const visible = categories.slice(0, MAX_CATEGORIES)
  const extra = categories.length - visible.length

  return (
    <CardActionArea
      onClick={onSelect}
      aria-current={selected || undefined}
      data-testid={testId}
      sx={[styles.card, selected && styles.selected]}
    >
      <Stack direction="row" sx={{ gap: 1, alignItems: 'flex-start' }}>
        <Typography variant="h5" data-testid={`${testId}-title`} sx={styles.title}>
          {data.title}
        </Typography>
        <Chip size="small" label={data.policy} data-testid={`${testId}-policy`} sx={{ flexShrink: 0 }} />
      </Stack>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        Last update: {dayjs(data.updatedAt).format('L LT')}
      </Typography>
      <Stack direction="row" sx={styles.chipRow}>
        {visible.map((category) => (
          <Chip key={category} size="small" variant="outlined" label={category} data-testid={`${testId}-category`} />
        ))}
        {extra > 0 && (
          <Typography variant="caption" sx={styles.more}>
            +{extra} more
          </Typography>
        )}
      </Stack>
    </CardActionArea>
  )
}

SOP.Loading = function Loading() {
  return (
    <Stack sx={styles.card}>
      <Typography variant="h5">
        <Skeleton width="60%" />
      </Typography>
      <Stack direction="row" sx={styles.chipRow}>
        <Skeleton width={70} />
        <Skeleton width={50} />
        <Skeleton width={50} />
      </Stack>
    </Stack>
  )
}

const styles = {
  card: {
    display: 'block',
    p: 1.5,
    borderRadius: 2.5,
    transition: (theme) => theme.transitions.create('background-color', { duration: theme.transitions.duration.shortest }),
    '&:hover': { bgcolor: 'action.hover' },
  },
  selected: {
    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.14),
    boxShadow: (theme) => `inset 0 0 0 1.5px ${alpha(theme.palette.primary.main, 0.5)}`,
    '&:hover': { bgcolor: (theme) => alpha(theme.palette.primary.main, 0.18) },
  },
  title: {
    flex: '1 1 auto',
    minWidth: 0,
    fontWeight: 600,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  chipRow: {
    flexWrap: 'wrap',
    gap: 0.5,
    mt: 1,
  },
  more: {
    display: 'inline-flex',
    alignItems: 'center',
    color: 'text.secondary',
    fontWeight: 600,
  },
}
